import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Datepicker from "components/Input/Datepicker/Datepicker";
import s from "./ExportContent.module.scss";

const ExportContent = ({ handleInput }) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState({
    startDate: "",
    endDate: "",
  });
  const [focus, setFocus] = useState({
    startDate: false,
    endDate: false,
  });

  const dateOnChange = (e, type) => {
    const rawDate = JSON.parse(JSON.stringify(e));
    const date = moment(rawDate).isValid()
      ? moment(rawDate).format("YYYY-MM-DD")
      : e !== null
      ? ""
      : null;
    if (type === "start") {
      setInputData({ ...inputData, startDate: date });
      handleInput(date, "startDate");
    }
    if (type === "end") {
      setInputData({ ...inputData, endDate: date });
      handleInput(date, "endDate");
    }
  };
  const startDateOnFocus = () => {
    setFocus({ startDate: true });
  };
  const startDateOnBlur = () => {
    setFocus({ startDate: false });
  };
  const endDateOnFocus = () => {
    setFocus({ endDate: true });
  };
  const endDateOnBlur = () => {
    setFocus({ endDate: false });
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <Datepicker
          label={t(
            "page.finance.payment.gateway.cost.export.function.dialog.content.1",
          )}
          value={inputData.startDate}
          limitValue={inputData.endDate}
          type="start"
          onchangeFn={dateOnChange}
          onfocusFn={startDateOnFocus}
          onblurFn={startDateOnBlur}
          sxParams={{
            datepickerFocus: focus.startDate,
          }}
        />
      </div>
      <div>
        <Datepicker
          label={t(
            "page.finance.payment.gateway.cost.export.function.dialog.content.2",
          )}
          value={inputData.endDate}
          limitValue={inputData.startDate}
          type="end"
          onchangeFn={dateOnChange}
          onfocusFn={endDateOnFocus}
          onblurFn={endDateOnBlur}
          sxParams={{
            datepickerFocus: focus.endDate,
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(ExportContent);
